import { useParams } from 'react-router-dom';
import PageHeader, { PageHeaderAction } from '../components/PageHeader'
import { useOrganization } from '../context/OrganizationContext';
import { useFirebaseDoc, useFirebaseQuery } from '../hooks/firebaseHooks';
import { Customer } from '../models/shared/Customer';
import { COLLECTIONS, PATHS } from '../utils/shared/constants';
import { useText } from '../context/TextContext';
import CustomerName from '../components/CustomerName';
import CustomerContact from '../components/CustomerContact';
import AccountingSystemBadge from '../components/AccountingSystemBadge';
import { doc, setDoc, where } from 'firebase/firestore';
import { useFirestore } from 'reactfire';
import React from 'react';
import { toast } from 'react-toastify';
import { Deal } from '../models/shared/Deal';
import DealModal from '../components/modals/DealModal';
import { renderDealContent } from '../utils/presentation';
import { DEFAULT_CARD_LAYOUT } from '../models/shared/CardLayout';



export default function CustomerPage() {
    const text = useText();
    const { orgId, organization } = useOrganization();
    const { customerId } = useParams<{ customerId: string }>()
    const [customer] = useFirebaseDoc<Customer>(`${COLLECTIONS.ORGANIZATIONS}/${orgId}/${COLLECTIONS.CUSTOMERS}/${customerId}`);
    const [deals] = useFirebaseQuery<Deal>(`${COLLECTIONS.ORGANIZATIONS}/${orgId}/${COLLECTIONS.DEALS}`, where('customerId', '==', customerId));
    const firestore = useFirestore();
    const [processing, setProcessing] = React.useState(false);
    const [selectedDeal, setSelectedDeal] = React.useState<Deal | null>(null);

    const isArchived = customer?.status === 'archived';
    const actions: PageHeaderAction[] = [];

    const handleUnarchive = async () => {
        setProcessing(true);

        try {

            const customerUpdate: Partial<Customer> = {
                status: 'active'
            }
            await setDoc(doc(firestore, `${COLLECTIONS.ORGANIZATIONS}/${orgId}/${COLLECTIONS.CUSTOMERS}/${customerId}`), customerUpdate, { merge: true });
            toast.success(text.defaultSuccess)
        } catch (error) {
            console.error(error);
            toast.error(text.defaultError)
        }

        setProcessing(false);
    }

    if (isArchived) {
        actions.push({ text: text.unarchive, icon: 'bi-recycle', onClick: handleUnarchive, processing });
    } else {
        actions.push({ text: text.edit, icon: 'bi-pencil', link: `${PATHS.CUSTOMERS_EDIT}/${customerId}` });
    }

    const layout = organization.cardLayout || DEFAULT_CARD_LAYOUT;
    return <>
        <PageHeader
            showBackButton
            title={<CustomerName customer={customer} />}
            titleSuffix={
                <>
                    {isArchived && <span className="badge bg-warning text-dark">{text.archived}</span>}
                    <AccountingSystemBadge customer={customer} accountingType={organization.integrations?.accountingType} />
                </>
            }
            actions={actions}
        />

        <div className='d-flex flex-column gap-4'>
            <div>
                <h6>{text.contact}</h6>
                <CustomerContact customer={customer} />
            </div>

            <div>
                <h6>{text.deals}</h6>
                {deals.length
                    ? <div className='d-flex flex-column gap-2 align-items-start'>
                        {deals.map(deal => <div key={deal.id} className='pointer' onClick={() => setSelectedDeal(deal)}>
                            <p className='m-0'>{renderDealContent(layout.title, deal, [], text)}</p>
                            <p className='m-0 small text-muted'>{renderDealContent(layout.subtitle, deal, [], text)}</p>
                        </div>)}
                    </div>
                    : <div>{text.noDeals}</div>
                }
            </div>
        </div>


        {selectedDeal && <DealModal deal={selectedDeal} onClose={() => setSelectedDeal(null)} />}
    </>
}
